import { render, staticRenderFns } from "./InstantDeath.vue?vue&type=template&id=6638ae52&scoped=true"
import script from "./InstantDeath.vue?vue&type=script&lang=ts"
export * from "./InstantDeath.vue?vue&type=script&lang=ts"
import style0 from "./InstantDeath.vue?vue&type=style&index=0&id=6638ae52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638ae52",
  null
  
)

export default component.exports